import { ShieldAlert, X } from "lucide-react";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface PolicyAssistantReminderModalProps {
  open: boolean;
  onClose: () => void;
}

export default function PolicyAssistantReminderModal({
  open,
  onClose,
}: PolicyAssistantReminderModalProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-xl rounded-md border-primary-100 bg-white p-0 text-primary-500">
        <DialogHeader className="border-b border-gray-100 px-6 py-5 text-left">
          <div className="flex items-start justify-between gap-4">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-agent-policygpt text-white">
                <ShieldAlert className="h-5 w-5" />
              </span>
              <DialogTitle className="text-xl font-medium text-primary-500">
                Important Reminder
              </DialogTitle>
            </div>
            <DialogClose
              aria-label="Close"
              className="rounded-md p-1 text-secondary hover:bg-gray-100 active:bg-gray-200"
            >
              <X className="h-5 w-5" />
            </DialogClose>
          </div>
        </DialogHeader>

        <DialogDescription className="px-6 py-5 font-secondary text-base leading-7 text-[#373A3C]">
          AI responses may be incomplete, inaccurate, or misleading. Information
          provided by this tool must be reviewed and applied thoughtfully to
          your role at CHOP. You are responsible for reviewing CHOP policies,
          and using your professional judgment to ensure the safe delivery of
          care, treatment, and services to patients and families.
        </DialogDescription>

        <DialogFooter className="border-t border-gray-100 px-6 py-4">
          <DialogClose className="w-full rounded-md bg-primary-500 px-4 py-3 font-primary text-sm text-white hover:opacity-90 active:opacity-80 sm:w-auto">
            I understand
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
